import { updateState } from './updateState';

const processReducerValue = (value, statusKey, nextStatus) => {
  let finalReducer = (state) => state;
  switch (typeof value) {
    case 'object':
      let reducer;
      let next;
      if (Array.isArray(value)) {
        [reducer, next] = value;
      } else {
        ({ reducer, next } = value);
      }
      if (typeof reducer === 'function') {
        finalReducer = processReducerValue(reducer, statusKey, next);
      } else if (next) {
        finalReducer = processReducerValue(next, statusKey);
      }
      break;
    case 'string':
      finalReducer = (state) => updateState(state, { [statusKey]: { $set: value } });
      break;
    case 'function':
      if (nextStatus) {
        finalReducer = (state, action) => ({ ...value(state, action), [statusKey]: nextStatus });
      } else {
        finalReducer = (state, action) => value(state, action);
      }
      break;
    default:
      finalReducer = (state) => state;
      break;
  }
  return finalReducer;
};

export const createFSMReducer = (
  initState,
  { statusKey = 'status', initial, states, actionReducers },
) => {
  const initialState = {
    ...initState,
    [statusKey]: initial,
  };

  return (state = initialState, action = {}) => {
    let newState = state;

    const currentStatus = state[statusKey];
    if (currentStatus in states) {
      const { accepts = [], rejects = [] } = states[currentStatus] || {};

      if (accepts === '*' || (accepts.includes(action.type) && !rejects.includes(action.type))) {
        const reducer = processReducerValue(actionReducers[action.type], statusKey);
        newState = reducer(state, action);
      }
    }

    return newState;
  };
};
